import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "grid grid-cols-2 md:grid-cols-2 gap-4" }
const _hoisted_2 = { class: "flex items-center gap-2 mb-1" }
const _hoisted_3 = { class: "text-xs text-gray-400" }
const _hoisted_4 = { class: "flex items-baseline" }
const _hoisted_5 = { class: "text-xl font-semibold text-white" }




export default /*@__PURE__*/_defineComponent({
  __name: 'FlowMetrics',
  props: {
    metrics: {}
  },
  setup(__props: any) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.metrics, (metric, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "bg-white/5 rounded-lg p-3 transition-all hover:bg-teal-900/20"
      }, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(metric.icon), { class: "h-4 w-4 text-teal-400" })),
          _createElementVNode("span", _hoisted_3, _toDisplayString(metric.label), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(metric.value), 1),
          (metric.change !== undefined)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: _normalizeClass(["ml-2 text-xs", metric.change >= 0 ? 'text-green-400' : 'text-red-400'])
              }, null, 2))
            : _createCommentVNode("", true)
        ])
      ]))
    }), 128))
  ]))
}
}

})